const STATUS_LABELS = {
  completed: "Completed",
  ready_for_possession: "Ready for Possession",
  under_development: "Under Development",
  booking_open: "Booking Open",
  coming_soon: "Coming Soon",
  sold_out: "Sold Out",
};

export const statusLabel = (s) => STATUS_LABELS[s] || s;
